/**
 * Couleurs des joueurs.
 *
 * Chaque compte a sa couleur: ce qu'il construit la porte, ce qui permet de
 * reconnaitre d'un coup d'oeil qui a bati quoi dans un monde partage. Le compte
 * d'administration a la sienne.
 *
 * Les couleurs sont indexees par NOM DE COMPTE en minuscules, pas par jeton: un
 * jeton est aleatoire et illisible, alors que le nom est stable et affichable.
 */

/** Couleur d'un joueur sans compte (mode invite). */
export const COULEUR_INVITE = 0x8f9aa6

/**
 * Nom porte par ce qu'un invite signe: sa toile au musee.
 *
 * Il n'est dans AUCUN compte, donc `couleurCompte` lui rend le gris des
 * invites sans qu'on ait a le dire deux fois — et `estAdmin` lui repond non.
 */
export const NOM_INVITE = 'invité'

export const COULEURS_COMPTE: Readonly<Record<string, number>> = {
  amelia: 0x3b82f6,
  zac: 0xe4392f,
  elliot: 0x22c55e,
  jcr: 0xf5c518,
}

/** Comptes disposant des pouvoirs d'administration. */
export const COMPTES_ADMIN: readonly string[] = ['jcr']

/** Couleur associee a un compte, ou la couleur des invites. */
export function couleurCompte(compte: string | null | undefined): number {
  if (!compte) return COULEUR_INVITE
  return COULEURS_COMPTE[compte.trim().toLowerCase()] ?? COULEUR_INVITE
}

/** Vrai si ce compte peut administrer le monde. */
export function estAdmin(compte: string | null | undefined): boolean {
  if (!compte) return false
  return COMPTES_ADMIN.includes(compte.trim().toLowerCase())
}

/**
 * Teinte les couleurs d'un batiment vers la couleur du proprietaire.
 *
 * On ne remplace pas les couleurs choisies par le joueur: on melange, pour que
 * la maison reste la sienne tout en s'affichant dans sa couleur d'equipe.
 */
export function melangerVersProprietaire(couleur: number, compte: string | null, force = 0.55): number {
  const cible = couleurCompte(compte)
  const cr = (couleur >> 16) & 255
  const cg = (couleur >> 8) & 255
  const cb = couleur & 255
  const tr = (cible >> 16) & 255
  const tg = (cible >> 8) & 255
  const tb = cible & 255
  const r = Math.round(cr + (tr - cr) * force)
  const g = Math.round(cg + (tg - cg) * force)
  const b = Math.round(cb + (tb - cb) * force)
  return (r << 16) | (g << 8) | b
}
